import { Component } from '@angular/core';
import { faSpinner as falSpinnerThird } from "@fortawesome/free-solid-svg-icons/faSpinner";

@Component({
  selector: 'app-loader',
  template: `
    <fa-icon [icon]="loader" [spin]="true" size="1x"></fa-icon>
  `
})
export class LoaderComponent {

  loader = falSpinnerThird;

}
